let apiUrl = "";
if (process.env.NODE_ENV === "development") {
  apiUrl = "http://localhost:3000"
} else {
  switch (process.env.REACT_APP_API_DOMAIN) {
    case "development": { apiUrl = "http://localhost:3000"; break; }
    case "production":  { apiUrl = "https://api.gethealthie.com"; break; }
    case "staging":     { apiUrl = "https://app-9377.on-aptible.com"; break; }
    default:            { throw new Error("invalid rootUrl config") }
  };
}

let inStoreFormId = "";
if (process.env.NODE_ENV === "development") {
  inStoreFormId = "1650"
} else {
  switch (process.env.REACT_APP_API_DOMAIN) {
    case "development": { inStoreFormId = "1650"; break; }
    case "production":  { inStoreFormId = "442690"; break; }
    case "staging":     { inStoreFormId = ""; break; }
    default:            { throw new Error("invalid inStoreForm config") }
  };
}

let  atHomeFormId = "";
if (process.env.NODE_ENV === "development") {
  atHomeFormId = "1650"
} else {
  switch (process.env.REACT_APP_API_DOMAIN) {
    case "development": { atHomeFormId = "1650"; break; }
    case "production":  { atHomeFormId = "406757"; break; }
    case "staging":     { atHomeFormId = ""; break; }
    default:            { throw new Error("invalid atHomeForm config") }
  };
}

let providerId = "";
if (process.env.NODE_ENV === "development") {
  providerId = "8"
} else {
  switch (process.env.REACT_APP_API_DOMAIN) {
    case "development": { providerId = "8"; break; }
    case "production":  { providerId = "1253862"; break; }
    case "staging":     { providerId = "1"; break; }
    default:            { throw new Error("invalid providerId config") }
  };
}

let gaPropertyId = "";
if (process.env.NODE_ENV === "development") {
  gaPropertyId = ""
} else {
  switch (process.env.REACT_APP_API_DOMAIN) {
    case "development": { gaPropertyId = ""; break; }
    case "production":  { gaPropertyId = "UA-7555952-46"; break; }
    case "staging":     { gaPropertyId = ""; break; }
    default:            { throw new Error("invalid GA config") }
  };
}

export {apiUrl, atHomeFormId, providerId, inStoreFormId, gaPropertyId};

